var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbbeLogoMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 23,
    viewBox: "0 0 46 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4999 9.90469C40.6684 6.1029 34.1369 5.35817 28.5918 7.97391L28.0509 8.22675L37.2867 13.7754L45.4999 9.90469Z",
    fill: "#00B2B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4068 14.0182L17.5162 12.8572L4.17379 19.2839C9.17308 23.3012 15.9313 24.093 21.6737 21.3241L34.4799 15.1597C29.617 17.2291 24.0204 16.8502 19.4068 14.0182Z",
    fill: "#00B2B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1207 2.34948C12.6707 -0.860674 5.86531 -0.776688 0.500061 2.57345L17.9654 12.8571L28.0511 8.19588L18.1207 2.34948Z",
    fill: "#AFD100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8461 8.26536L17.9492 13.0027L19.8057 14.136C24.3362 16.9007 29.8319 17.2705 34.6072 15.2504L37.2349 13.989L27.8461 8.26536Z",
    fill: "#251163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbbeLogoMin);
export default __webpack_public_path__ + "static/media/ubbe_logo_min.8f52866243f7635f0b34d8465ef4dc8d.svg";
export { ForwardRef as ReactComponent };